import Swal from 'sweetalert2';

export function showAlert(alertText: any, alertIcon: any) {
  Swal.fire({
    position: 'top-end',
    icon: alertIcon,
    text: alertText,
    showConfirmButton: false,
    timer: 1500,
    toast: true,
  });
}

export function showCustomAlert(
  alertTitle: string,
  alertText: any,
  alertIcon: any,
  isToast: boolean,
  position: any,
  timer: number = 4000
) {
  Swal.fire({
    title: alertTitle,
    position: position,
    icon: alertIcon,
    html: alertText,
    showConfirmButton: false,
    timer,
    toast: isToast,
    didOpen: (popup) => {
      const container = popup.closest('.swal2-container') as HTMLElement;
      if (container) container.style.zIndex = '999999';
    },
  });
}

export function showCustomConfirmAlert(
  alertTitle: string,
  alertText: any,
  alertIcon: any,
  isToast: boolean,
  position: any,
  callback: any,
  confirmButtonText: string = 'Ok',
  confirmButtonColor: string = '#4cbfa6',
  showCancel: boolean = false,
  cancelButtonText: string = '',
) {
  Swal.fire({
    title: alertTitle,
    position: position,
    icon: alertIcon,
    html: alertText,
    showConfirmButton: true,
    toast: isToast,
    confirmButtonText,
    confirmButtonColor,
    showCancelButton: showCancel,
    cancelButtonText: cancelButtonText,
  }).then(function (result) {
    if (result.isConfirmed) {
      callback();
    }
  });
}
